/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Folder': {
    width: 32,
    height: 26,
    viewBox: '0 0 32 26',
    data: '<path pid="0" d="M32 8v17c0 1-1 1-1 1H1s-1 0-1-1V8h32zM1 0h8.5C10.557 0 11 1 11 1l1 2h19s1 0 1 1v3H0V1c0-1 1-1 1-1z" _fill="#D6AC2D" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/Folder.js